/* eslint-disable prettier/prettier */
import f from './../scripts/functions'
export default class URL {
    constructor() {
        this._url = ''
        this._host = ''
        this._params = {}
    }
    
    get url() { return this._url }
    set url(_val) {
        this._url = _val
        if (_val && _val != '') { this.params = f.GetParamsFromURL(_val) }
    }

    get host() { return this._host }
    set host(_val) { this._host = _val }

    get params() { return this._params }
    set params(_val) { this._params = _val }

    addParam = (_str) => {
      this._params[_str.split('=')[0]] = _str.split('=')[1]
    }

    get urlWithParams() {
      let _baseUrl = this._url.split('?')[0]
      let _ixCount = 0
      for (let _p in this._params) {
        if (this._params[_p] && this._params[_p] != '') {
          let _par = `${_p}=${this._params[_p]}`
          if (_ixCount === 0) {
            _baseUrl = `${_baseUrl}?${_par}`
          } else {
            _baseUrl = `${_baseUrl}&${_par}`
          }
          _ixCount += 1
        }
      }
      return _baseUrl
    }
  }
  